import { render, staticRenderFns } from "./Eliza.vue?vue&type=template&id=5c8e8ecf&scoped=true"
import script from "./Eliza.vue?vue&type=script&lang=js"
export * from "./Eliza.vue?vue&type=script&lang=js"
import style0 from "./Eliza.vue?vue&type=style&index=0&id=5c8e8ecf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8e8ecf",
  null
  
)

export default component.exports